import { isArray } from "util";
import { isInArray } from "./is-in-array";

export const removeFromArray = (array: Array<any>, valuesToRemove: any | Array<any>): Array<any> => {

    return array.filter(item => {

        if (isArray(valuesToRemove)) {
            return !isInArray(item, valuesToRemove);
        } else {
            return item !== valuesToRemove;
        }
    });
};



// WEBPACK FOOTER //
// ./src/core/util/remove-from-array.ts